export default __webpack_public_path__ + "static/media/pdv_w_bg.a5bcd1d5.png";